// extracted by mini-css-extract-plugin
export default {"img":"styles_img__cO7o-","fadeIn":"styles_fadeIn__FMQLc"};